import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ServerErrorDialogComponent } from './shared/components/server-error-dialog/server-error-dialog.component';
import { HealthService } from './core/services/health.service';
import { MaintenanceComponent } from './features/auth/maintenance.component';
import { UserInteractionService } from './core/services/user-interaction.service';


@Component({
    selector: 'app-root',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '(window:keydown.tab)': 'onTabKey()',
        '(window:mousedown)': 'onMouseDown()'
    },
    template: `
        @if (!healthService.initialized()) {
            <!-- Loading state while checking backend -->
            <div class="startup-loading">
                <div class="startup-content">
                    <div class="startup-logo">
                        <img src="assets/img/Logo_stela_blanco.png" alt="Stela" />
                    </div>
                    <div class="spinner"></div>
                    <p>Conectando con el servidor...</p>
                </div>
            </div>
        } @else if (!healthService.status().isHealthy) {
            <!-- Backend is down - show maintenance screen -->
            <app-maintenance (retrySuccess)="onBackendRestored()"></app-maintenance>
        } @else {
            <!-- Backend is healthy - show normal app -->
            <router-outlet></router-outlet>
            <server-error-dialog></server-error-dialog>
        }
    `,
    styles: [`
        .startup-loading {
            min-height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            background: var(--stela-aubergine);
            padding: 20px;
        }

        .startup-content {
            background: white;
            border-radius: 4px;
            padding: 40px;
            max-width: 400px;
            width: 100%;
            text-align: center;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .startup-logo {
            margin-bottom: 30px;
        }

        .startup-logo img {
            width: 120px;
            height: auto;
            display: block;
            margin: 0 auto;
            animation: fadeIn 0.6s ease-in-out;
        }

        @keyframes fadeIn {
            from { opacity: 0; transform: translateY(-10px); }
            to { opacity: 1; transform: translateY(0); }
        }

        .startup-loading p {
            margin-top: 20px;
            font-size: 16px;
            color: #676a6c;
        }

        .spinner {
            width: 50px;
            height: 50px;
            border: 4px solid #f3f3f4;
            border-top-color: #ecba52;
            border-radius: 50%;
            animation: spin 1s linear infinite;
        }

        @keyframes spin {
            to { transform: rotate(360deg); }
        }
    `],
    imports: [RouterOutlet, MaintenanceComponent, ServerErrorDialogComponent]
})
export class AppComponent implements OnInit {
    protected healthService = inject(HealthService);
    private readonly userInteraction = inject(UserInteractionService);

    onTabKey(): void {
        document.body.classList.add('user-is-tabbing');
    }

    onMouseDown(): void {
        document.body.classList.remove('user-is-tabbing');
    }

    ngOnInit(): void {
        // Check backend health on startup
        void this.healthService.checkHealth();
    }

    onBackendRestored(): void {
        // Backend is back online - the signal update will trigger template change
        // No additional action needed since HealthService already updated its status
    }
}
